import { Send, X } from "lucide-react";
import { motion, AnimatePresence } from "motion/react";
import { Button } from "@/app/components/button";

interface OfferSentToastProps {
  isOpen: boolean;
  onClose: () => void;
}

export function OfferSentToast({ isOpen, onClose }: OfferSentToastProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/20 z-50"
          />

          {/* Toast - same size as add-to-cart toast */}
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="fixed bottom-0 left-0 right-0 z-50 mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8 pb-6"
          >
            <div className="bg-card border border-border rounded-2xl shadow-2xl overflow-hidden">
              {/* Header */}
              <div className="bg-primary p-4 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <Send className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white">Oferta enviada!</h3>
                    <p className="text-xs text-white/80">
                      Sua oferta foi enviada ao vendedor
                    </p>
                  </div>
                </div>
                <button
                  onClick={onClose}
                  className="p-2 hover:bg-white/10 rounded-lg transition-colors"
                  aria-label="Fechar"
                >
                  <X className="w-5 h-5 text-white" />
                </button>
              </div>

              {/* Content */}
              <div className="p-4">
                <p className="text-sm text-muted-foreground mb-4">
                  O vendedor será notificado e você pode acompanhar a oferta no chat ou em Menu → Negociações → Ofertas Enviadas.
                </p>
                <Button onClick={onClose} className="w-full" size="lg">
                  Continuar
                </Button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
